module.exports = __webpack_public_path__ + "static/media/stripe-express-onboarding_8.86bbe3a6.png";